var classes = {"root":"VBOmU"};

export { classes as default };
